import type { GhostPost, SelectResultFn } from "../../types";
import { useAppContext } from "../../contexts/AppContext";
import HighlightedSection from "./HighlightedSection";

interface PostListItemProps {
  post: GhostPost;
  selectedResult: string | null;
  setSelectedResult: SelectResultFn;
}

export default function PostListItem({
  post,
  selectedResult,
  setSelectedResult,
}: PostListItemProps) {
  const { searchValue } = useAppContext();
  const { title, excerpt, url, id } = post;
  let className = "py-3 -mx-4 sm:-mx-7 px-4 sm:px-7 cursor-pointer";
  if (id === selectedResult) {
    className += " bg-neutral-100";
  }
  return (
    <div
      className={className}
      onClick={() => {
        if (url) {
          window.location.href = url;
        }
      }}
      onMouseEnter={() => setSelectedResult(id)}
    >
      <h2 className="text-[1.65rem] font-medium leading-tight text-neutral-800">
        <HighlightedSection
          text={title}
          highlight={searchValue}
          isExcerpt={false}
        />
      </h2>
      <p className="text-neutral-400 leading-normal text-sm mt-0 mb-0 truncate">
        <HighlightedSection
          text={excerpt}
          highlight={searchValue}
          isExcerpt={true}
        />
      </p>
    </div>
  );
}
